import { participantsInfoFromSearchResults } from 'utils/participants'

import {
  PARTICIPANTS_EXCLUDE_FILTER_VALUES,
  PARTICIPANTS_GROUP_KEYS,
} from 'containers/AwarenessCenter/constants'

import {
  CHANGE_EXCLUDE_FILTER,
  CHANGE_MODAL_SEARCH,
  CHANGE_MSP_PARTICIPANTS_MODAL_PAGE,
  CHANGE_PARTICIPANTS_MODAL_PAGE,
  CHANGE_PARTICIPANTS_SELECTION,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  CHANGE_SELECTION_DATA,
  CONFIG_CONFLICT,
  CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  FETCH_AUTONOMOUS_SCHEDULE_ASYNC,
  GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC,
  GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC,
  GET_PARTICIPANTS_ASYNC,
  GET_PARTICIPANTS_INFO_ASYNC,
  SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC,
  SEARCH_PARTICIPANTS_INFO_ASYNC,
  SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC,
  UPDATE_PARTICIPANTS_NUMBERS_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    months: [],
    loader: false,
    submitLoader: false,
    createMemberLoader: false,
    participantsInfoLoader: false,
    isMemberRemoving: false,
    membersCount: 0,
    error: null,
    members: {
      page: 1,
      loader: false,
      error: null,
      items: [],
      meta: {
        count: 0,
      },
    },
    candidates: {
      loader: false,
      error: null,
      items: [],
      meta: {
        count: 0,
      },
    },
    participants: {
      page: 1,
      modalLoader: false,
      selectorLoader: false,
      error: null,
      modalSearch: '',
      excludeFilter: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
      included: {},
      excluded: {},
      items: [],
      meta: {
        count: 0,
      },
      includedSelectionIds: [],
      excludedSelectionIds: [],
    },
    participantsNumbers: [],
    participantsInfoToInclude: {},
    participantsInfoToIncludeMsp: [],
    conflictedCompanies: [],
  }

  return (state = initialState, action) => {
    let participantsInfoToIncludeMsp
    let participantsInfoToInclude = {}

    switch (action.type) {
      case GET_PARTICIPANTS_INFO_ASYNC.SUCCESS:
        participantsInfoToIncludeMsp = state.participantsInfoToIncludeMsp

        if (participantsInfoToIncludeMsp.length) {
          // MSP case
          participantsInfoToIncludeMsp[action.payload.index] = action.payload.data
        }

        return {
          ...state,
          participantsInfoToInclude: action.payload.data,
          participantsInfoToIncludeMsp,
          error: null,
          participantsInfoLoader: false,
        }
      case SEARCH_PARTICIPANTS_INFO_ASYNC.SUCCESS:
        if (Array.isArray(action.payload.data)) {
          participantsInfoToInclude = participantsInfoFromSearchResults(action.payload.data)
        } else {
          participantsInfoToInclude = action.payload.data
        }

        participantsInfoToIncludeMsp = state.participantsInfoToIncludeMsp

        if (participantsInfoToIncludeMsp.length) {
          // MSP case
          participantsInfoToIncludeMsp[action.payload.index] = participantsInfoToInclude
        }

        return {
          ...state,
          participantsInfoLoader: false,
          participantsInfoToInclude,
          participantsInfoToIncludeMsp,
        }
      case FETCH_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          participantsInfoLoader: true,
        }
      case FETCH_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS:
        return {
          ...state,
          months: action.payload.data.months,
          participants: {
            ...state.participants,
            // included/excluded must stay objects (selectors call Object.keys on
            // them); guard against a missing/malformed payload so a bad response
            // degrades to "no participants" instead of crashing the page.
            included: action.payload.data.participants_choices || {},
            excluded: action.payload.data.participants_exclude_choices || {},
          },
          loader: false,
        }
      case SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE:
        return {
          ...state,
          submitLoader: true,
        }
      case SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS:
        return {
          ...state,
          submitLoader: false,
          months: action.payload.months,
        }
      case SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.ERROR:
      case FETCH_AUTONOMOUS_SCHEDULE_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
          submitLoader: false,
        }
      case SUBMIT_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL:
      case FETCH_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          submitLoader: false,
        }
      case GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS:
        return {
          ...state,
          months: action.payload.data.months,
          membersCount: action.payload.data.membersCount,
          loader: false,
        }
      case GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case GET_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          error: null,
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE:
        return {
          ...state,
          members: {
            ...state.members,
            loader: true,
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS:
        return {
          ...state,
          participantsNumbers: action.payload.data.items.map(
            ({ participantsCount }) => participantsCount
          ),
          participantsInfoToIncludeMsp: !state.participantsInfoToIncludeMsp.length
            ? Array(action.payload.data.items.length).fill({})
            : state.participantsInfoToIncludeMsp,
          members: {
            ...state.members,
            loader: false,
            items: action.payload.data.items,
            meta: {
              count: action.payload.data.meta.count,
            },
          },
        }
      case UPDATE_PARTICIPANTS_NUMBERS_ASYNC.SUCCESS:
        return {
          ...state,
          participantsNumbers: action.payload.data.items.map(
            ({ participantsCount }) => participantsCount
          ),
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR:
        return {
          ...state,
          members: {
            ...state.members,
            loader: false,
            error: action.error,
            items: [],
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.CANCEL:
        return {
          ...state,
          members: {
            ...state.members,
            loader: false,
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.INITIATE:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: true,
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.SUCCESS:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: false,
            items: action.payload.data.items,
            meta: {
              count: action.payload.data.meta.count,
            },
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.ERROR:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: false,
            error: action.error,
          },
        }
      case GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_CANDIDATES_ASYNC.CANCEL:
        return {
          ...state,
          candidates: {
            ...state.candidates,
            loader: false,
          },
        }
      case CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE:
        return {
          ...state,
          createMemberLoader: true,
        }
      case CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS:
        return {
          ...state,
          createMemberLoader: false,
        }
      case CREATE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR:
        return {
          ...state,
          createMemberLoader: false,
          error: action.error,
        }
      case DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.INITIATE:
        return {
          ...state,
          isMemberRemoving: true,
        }
      case DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS:
        return {
          ...state,
          isMemberRemoving: false,
        }
      case DELETE_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR:
        return {
          ...state,
          isMemberRemoving: false,
          error: action.error,
        }
      case SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          submitLoader: true,
        }
      case SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.SUCCESS:
        return {
          ...state,
          submitLoader: false,
          conflictedCompanies: [],
        }
      case SAVE_GROUP_AUTONOMOUS_SCHEDULE_ASYNC.ERROR:
        const conflictedCompanies =
          action.error.response.error[0] === CONFIG_CONFLICT
            ? action.error.response.companies
            : state.conflictedCompanies

        return {
          ...state,
          submitLoader: false,
          error: action.error.response.error,
          conflictedCompanies,
        }
      case CHANGE_PARTICIPANTS_SELECTION: {
        const participantsData = {
          ...state.participants,
          selectorLoader: true,
        }

        if (
          action.payload.key === PARTICIPANTS_GROUP_KEYS.INCLUDED &&
          Object.values(action.payload.value).length === 0
        ) {
          // cleared selected, clear also excluded
          participantsData.excluded = {}
          participantsData.meta = {
            count: 0,
          }
        }

        participantsData[action.payload.key] = action.payload.value

        return {
          ...state,
          participants: participantsData,
          participantsInfoLoader: true,
        }
      }
      case CHANGE_PARTICIPANTS_TOTAL_SELECTION: {
        const participantsData = {
          ...state.participants,
          selectorLoader: true,
        }

        if (Object.values(action.payload.data.included).length === 0) {
          // cleared selected, clear also excluded
          participantsData.excluded = {}
          participantsData.meta = {
            count: 0,
          }
        } else {
          participantsData.excluded = action.payload.data.excluded
        }

        participantsData.included = action.payload.data.included

        return {
          ...state,
          participants: participantsData,
          participantsInfoLoader: true,
        }
      }
      case GET_PARTICIPANTS_ASYNC.INITIATE:
        return {
          ...state,
          participants: {
            ...state.participants,
            modalLoader: true,
            error: null,
          },
        }
      case GET_PARTICIPANTS_ASYNC.SUCCESS:
        return {
          ...state,
          participants: {
            ...state.participants,
            modalLoader: false,
            selectorLoader: false,
            error: null,
            items: action.payload.data.items,
            meta: {
              count: action.payload.data.meta.count,
            },
          },
        }
      case GET_PARTICIPANTS_ASYNC.ERROR:
        return {
          ...state,
          participants: {
            ...state.participants,
            meta: {
              ...state.participants.meta,
              count: 0,
            },
            modalLoader: false,
            selectorLoader: false,
            error: action.error,
          },
        }
      case CHANGE_EXCLUDE_FILTER:
        return {
          ...state,
          participants: {
            ...state.participants,
            modalLoader: true,
            excludeFilter: action.payload.value,
          },
        }
      case CHANGE_MODAL_SEARCH:
        return {
          ...state,
          participants: {
            ...state.participants,
            modalSearch: action.payload.search,
          },
        }
      case CHANGE_PARTICIPANTS_MODAL_PAGE:
        return {
          ...state,
          participants: {
            ...state.participants,
            page: action.payload.page,
            modalLoader: true,
          },
        }
      case CHANGE_MSP_PARTICIPANTS_MODAL_PAGE:
        return {
          ...state,
          members: {
            ...state.members,
            page: action.payload.page,
            loader: true,
          },
        }
      case CHANGE_SELECTION_DATA:
        return {
          ...state,
          participants: {
            ...state.participants,
            [action.payload.field]: action.payload.value,
          },
        }
      case SEARCH_PARTICIPANTS_INFO_ASYNC.INITIATE:
        return {
          ...state,
          participantsInfoLoader: true,
        }
      case SEARCH_PARTICIPANTS_INFO_ASYNC.ERROR:
        return {
          ...state,
          participantsInfoLoader: false,
          error: action.error,
        }
      default:
        return state
    }
  }
}
